'use strict';

const Event = require('./../lib/events');

class Slider {

    constructor() {

        this.doorwaySlider();
        this.featuredCustomerStoriesSlider();
        this.featuredSolutionsSlider();
        this.solutionsSlider();

    }

    doorwaySlider() {

        let doorwaySlider = document.querySelectorAll('.ce-doorway-slider');

        if (doorwaySlider.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of doorwaySlider) {

                new Swiper(slider.querySelector('.swiper-container'), {
                    simulateTouch: true,
                    spaceBetween: 48,
                    slidesPerView: 3,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 2,
                            spaceBetween: 32
                        },
                        768: {
                            spaceBetween: 15,
                            slidesPerView: 1
                        }
                    },
                    on: {
                        init: function () {
                            setTimeout(function () {
                                Event.trigger(window, 'resize');
                            }, 500);
                        },
                    }
                });

            }

        }

    }

    featuredCustomerStoriesSlider() {

        let featuredCustomerStoriesSlider = document.querySelectorAll('.ce-featured-customer-stories');

        if (featuredCustomerStoriesSlider.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of featuredCustomerStoriesSlider) {

                let paginationSwiper = new Swiper(slider.querySelector('.pagination-swiper'), {
                    centeredSlides: true,
                    initialSlide: 1,
                    slidesPerView: 3,
                    slideToClickedSlide: true,
                    spaceBetween: 20,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    breakpoints: {
                        1024: {
                            spaceBetween: 20,
                            slidesPerView: 3
                        },
                        768: {
                            centeredSlides: false,
                            initialSlide: 0,
                            slidesOffsetBefore: 24,
                            slidesOffsetAfter: 24,
                            slidesPerView: 1.5,
                            spaceBetween: 2,
                        }
                    },
                    on: {
                        init: function () {
                            setTimeout(function () {
                                Event.trigger(window, 'resize');
                            }, 500);
                        },
                    }
                });

                let contentSwiper = new Swiper(slider.querySelector('.content-swiper'), {
                    effect: 'fade',
                    initialSlide: 1
                });

                contentSwiper.controller.control = paginationSwiper;
                paginationSwiper.controller.control = contentSwiper;

            }

        }

    }

    featuredSolutionsSlider() {

        let featuredSolutionsSlider = document.querySelectorAll('.ce-featured-solutions-slider');

        if (featuredSolutionsSlider.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of featuredSolutionsSlider) {

                new Swiper(slider.querySelector('.swiper-container'), {
                    simulateTouch: true,
                    spaceBetween: 48,
                    slidesPerView: 3,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 2,
                            spaceBetween: 32
                        },
                        768: {
                            spaceBetween: 15,
                            slidesPerView: 1.25
                        }
                    },
                    on: {
                        init: function () {
                            setTimeout(function () {
                                Event.trigger(window, 'resize');
                            }, 500);
                        },
                    }

                });

            }

        }

    }

    solutionsSlider() {

        let solutionsSlider = document.querySelectorAll('.archive-solution');

        if (solutionsSlider.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of solutionsSlider) {

                new Swiper(slider.querySelector('.swiper-container'), {
                    simulateTouch: true,
                    spaceBetween: 48,
                    slidesPerView: 3,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 2,
                            spaceBetween: 32
                        },
                        768: {
                            spaceBetween: 15,
                            slidesPerView: 1
                        }
                    },
                    on: {
                        init: function () {
                            setTimeout(function () {
                                Event.trigger(window, 'resize');
                            }, 500);
                        },
                    }

                });

            }

        }

    }

}

module.exports = Slider;
